import "./sw-home.module.css";
import { html, LANGUAGE } from "../../global.ts";
import Strings from "../../../models/Strings.json";
import BUDDHA from "../../../public/buddha.mp4";
import BUDDHA2 from "../../../public/buddha.webp";

const template = document.createElement("template");
template.innerHTML = html`
    <header>
        <h1
            class="moul py-5 text-center text-lg font-extrabold leading-none tracking-tight text-gray-900 md:text-3xl lg:text-4xl dark:text-white">
            ${Strings.hero[LANGUAGE]}
        </h1>
        <h2
            class="moul pb-2 text-center text-base font-bold leading-none tracking-tight text-gray-900 md:text-2xl lg:text-3xl dark:text-white">
            ${Strings.subtitle[LANGUAGE]}
        </h2>
    </header>
    <main>
        <div class="relative cursor-pointer">
            <video
                onclick="heartbank.alertAdmin('home/click/buddha')"
                class="px-7 pt-1"
                src="${BUDDHA}"
                poster="${BUDDHA2}"
                playsinline
                loop
                autoplay
                muted>
                <!--<img class="p-7 mt-[-20px]" src="${BUDDHA2}" />-->
            </video>
            <p
                class="absolute text-center text-sm text-yellow-100 moul bottom-1 left-1/2 transform -translate-x-1/2">
                ${Strings.movie[LANGUAGE]}
            </p>
        </div>
        <p
            class="hidden text-center px-5 text-sm md:text-base text-gray-500 dark:text-gray-400">
            ${Strings.qrcode[LANGUAGE]}
        </p>
        <a href="#share">
            <p
                id="scroll-to-here"
                class="text-center px-5 pt-5 text-sm md:text-base text-gray-500 dark:text-gray-400">
                ${Strings.gift[LANGUAGE]} ${Strings.copy[LANGUAGE]}
            </p>
        </a>
        <picture
            onclick="heartbank.alertAdmin('home/click/qr-code')"
            class="relative cursor-pointer ml-[-10%] mb-[-19%] mt-[3%] inline-block w-full">
            <svg
                class="block fill-hb"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24">
                <path
                    d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                    transform="rotate(45 12 12)" />
            </svg>
            <img
                id="qr_code"
                alt="qr code"
                class="absolute w-[43%] ml-[-3%] mt-[3%] top-1/2 left-1/2 -rotate-90x transform -translate-x-1/2 -translate-y-1/2" />
        </picture>
        <p
            class="text-center px-5 pt-0 pb-0 text-sm md:text-base text-gray-500 dark:text-gray-400">
            ${Strings.scan[LANGUAGE]}
        </p>
        <!--<img id="qr_code" class="block md:hidden" />
        <img id="buddha_image src="${BUDDHA}" class="hidden md:block p-5" />-->
    </main>
    <footer id="sw-home-footer">
        <section
            class="m-5 block w-fit p-6 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
            ${LANGUAGE === "khmer"
                ? html`<h5
                          class="mb-5 text-lg font-bold tracking-tight text-gray-900 dark:text-white">
                          ព្រះត្រៃបិដក ដែលជាគម្ពីរសំខាន់នៃព្រះពុទ្ធសាសនា
                          មានបីផ្នែកគឺ ព្រះវិន័យ ព្រះសុត្តន្ត និង ព្រះអភិធម្ម
                          ដែលនីមួយៗមានគោលបំណងផ្សេងគ្នា ដូចខាងក្រោម៖
                      </h5>
                      <ol
                          class="text-base font-normal text-gray-700 dark:text-gray-400">
                          <li>
                              <h6>១. ព្រះវិន័យ</h6>
                              <p>
                                  គោលបំណង: ផ្តល់ច្បាប់ និងវិន័យសម្រាប់សង្ឃ
                                  និងសាមណេរ ដើម្បីគ្រប់គ្រងជីវិតសាសនា
                                  និងរក្សាសណ្តាប់ធ្នាប់ក្នុងសង្ឃសហគមន៍។
                              </p>
                              <p>
                                  ខ្លឹមសារ: ការកំណត់សីល វិន័យ
                                  និងក្រមសីលធម៌សម្រាប់ភិក្ខុ ភិក្ខុនី
                                  និងការដោះស្រាយទំនាស់ក្នុងសហគមន៍។
                                  វាជួយឱ្យសង្ឃរស់នៅប្រកបដោយសន្តិភាព
                                  និងផ្តោតលើការអនុវត្តធម៌។
                              </p>
                          </li>
                          <li>
                              <h6>២. ព្រះសុត្តន្ត</h6>
                              <p>
                                  គោលបំណង: បង្រៀនធម៌ និងការអនុវត្តផ្លូវអរិយមគ្គ
                                  ដើម្បីឈានទៅដល់ការត្រាស់ដឹង ឬនិព្វាន។
                              </p>
                              <p>
                                  ខ្លឹមសារ:
                                  ផ្ទុកនូវព្រះធម្មទេសនារបស់ព្រះសម្មាសម្ពុទ្ធ
                                  ដែលផ្តល់ការណែនាំអំពីសីល សមាធិ និងបញ្ញា
                                  ព្រមទាំងរឿងរ៉ាវជាតក និងការបង្រៀនសម្រាប់គ្រហស្ថ
                                  និងបព្វជិត។
                              </p>
                          </li>
                          <li>
                              <h6>៣. ព្រះអភិធម្ម</h6>
                              <p>
                                  គោលបំណង: វិភាគ និងពន្យល់យ៉ាងស៊ីជម្រៅអំពីធម៌
                                  ទាក់ទងនឹងចិត្ត ចេតសិក និងសភាពនៃអត្ថិភាព
                                  ដើម្បីជួយអ្នកសិក្សាយល់ច្បាស់អំពីសច្ចធម៌។
                              </p>
                              <p>
                                  ខ្លឹមសារ: ផ្តោតលើទស្សនវិជ្ជា
                                  និងចិត្តវិទ្យាពុទ្ធសាសនា ដោយបែងចែកចិត្ត
                                  សភាពធម៌ និងការពន្យល់អំពីបុគ្គលិកលក្ខណៈ
                                  និងកម្ម។
                              </p>
                              <p>
                                  សង្ខេប: ព្រះវិន័យ ផ្តោតលើសីល
                                  និងការគ្រប់គ្រងសង្ឃ។ ព្រះសុត្តន្ត
                                  បង្រៀនផ្លូវអនុវត្តធម៌ជាក់ស្តែង។ ព្រះអភិធម្ម
                                  ពន្យល់អំពីធម៌ជាទស្សនវិជ្ជា
                                  និងវិទ្យាសាស្ត្រនៃចិត្ត។
                              </p>
                              <!--<p class="indent-5">
                                  ព្រះវិន័យ ផ្តោតលើសីល និងការគ្រប់គ្រងសង្ឃ។
                              </p>
                              <p class="indent-5">
                                  ព្រះសុត្តន្ត បង្រៀនផ្លូវអនុវត្តធម៌ជាក់ស្តែង។
                              </p>
                              <p class="indent-5">
                                  ព្រះអភិធម្ម ពន្យល់អំពីធម៌ជាទស្សនវិជ្ជា
                                  និងវិទ្យាសាស្ត្រនៃចិត្ត។
                              </p>-->
                          </li>
                      </ol>
                      <h5
                          class="mt-5 text-lg font-bold tracking-tight text-gray-900 dark:text-white">
                          ទាំងបីផ្នែកនេះបំពេញគ្នាទៅវិញទៅមក
                          ដើម្បីណែនាំមនុស្សឆ្ពោះទៅរកការរំដោះចេញពីទុក្ខ។
                      </h5> `
                : html`<h5
                          class="mb-5 text-lg font-bold tracking-tight text-gray-900 dark:text-white">
                          The <strong>Pali-Khmer Tipiṭaka</strong>, translated
                          by the
                          <strong>Buddhist Institute of Cambodia</strong>, is
                          the Khmer-language version of the
                          <em>Theravāda Buddhist Canon</em>, composed of three
                          main collections:
                      </h5>
                      <ol
                          class="text-base font-normal text-gray-700 dark:text-gray-400">
                          <li>
                              <h6>1. Vinaya Piṭaka (Discipline Basket)</h6>
                              <p>
                                  Contains rules for monks and nuns, ethical
                                  conduct, and procedures to maintain harmony in
                                  the monastic community.
                              </p>
                              <p class="hidden">
                                  <strong>Key texts:</strong> Pārājika,
                                  Pācittiya, Mahāvagga, Cullavagga.
                              </p>
                          </li>
                          <li>
                              <h6>2. Suttanta Piṭaka (Discourse Basket)</h6>
                              <p>
                                  A large collection of the Buddha's teachings
                                  and stories, intended for both monks and lay
                                  followers.
                              </p>
                              <p class="hidden">
                                  <strong>Main sections:</strong> Dīgha Nikāya,
                                  Majjhima Nikāya, Saṃyutta Nikāya, Aṅguttara
                                  Nikāya, Khuddaka Nikāya (including Dhammapada,
                                  Jātaka tales).
                              </p>
                          </li>
                          <li>
                              <h6>
                                  3. Abhidhamma Piṭaka (Higher Teaching Basket)
                              </h6>
                              <p>
                                  A detailed scholastic analysis of the mind,
                                  matter, and mental phenomena, emphasizing
                                  systematic interpretation of reality.
                              </p>
                          </li>
                      </ol>
                      <h5
                          class="mt-5 text-lg font-bold tracking-tight text-gray-900 dark:text-white">
                          The Khmer translation was initiated in the 1920s by
                          Cambodian monks and scholars. The project produced
                          <strong>110 volumes</strong>, preserving authenticity
                          while using accessible, elegant Khmer for Cambodian
                          readers.
                      </h5>`}
        </section>
        <blockquote
            class="hidden p-4 my-4 border-s-4 border-gray-300 bg-gray-50 dark:border-gray-500 dark:bg-gray-800">
            <p
                id="buddha-quote"
                class="text-xl italic font-medium leading-relaxed text-gray-900 dark:text-white">
                ${Strings.buddha[LANGUAGE]}
            </p>
        </blockquote>
        <p
            class="text-lg arial text-center font-light leading-relaxed text-gray-900 dark:text-white">
            bedok.siliconwat.org
        </p>
    </footer>
`;

export default template;
